import { defineMessages } from 'react-intl.macro';

export const messages = defineMessages({
  'userDefinedRole.update.error': {
    defaultMessage: 'Failed to update user-defined role',
    id: 'userDefinedRole.update.error'
  },
  'userDefinedRole.update.pageTitle': {
    defaultMessage: 'Update User-Defined Role',
    id: 'userDefinedRole.update.pageTitle'
  },
  'userDefinedRole.update.success': {
    defaultMessage: 'Updated user-defined role',
    id: 'userDefinedRole.update.success'
  }
});
